<template>
  <div>
    <Navbar v-show="routemeta.navbar" />
    <Breadcrumb
      :breadcrumbOverride="breadcrumbOverride"
      v-show="routemeta.navbar"
    />
    <div class="container-xl" v-if="elearningmodule && elearningmodule.exam_id === '0'">
      <div class="border-0 text-container-wider">
        <div class="card-title">
          <h2 class="text-primary">
            {{ elearningmodule ? elearningmodule.module_name : '' }}
          </h2>
        </div>
        <div class="card-body mx-0 px-0 col-12">
          <div class="row mx-0 px-0">
            <div class="mx-0 px-0 col-xs-12 col-7">
              <span v-html="elearningmodule ? elearningmodule.module_introduction : ''"></span>
            </div>
            <div class="mx-0 px-0 col-xs-12 col-5 text-right text-top">
              <a
                :href="`/elearningcourse/${elearningmodule.course_id}`"
                class="btn btn-secondary mr-2"
              >
                Course overview
              </a>
              <button class="btn btn-secondary">Contact your tutor</button>
            </div>
          </div>
          <h3
            class="pt-4 mt-4"
            style="border-top: 1px solid black"
          >
            Steps
          </h3>
          <BaseTable
            class="mx-0 px-0 mb-4"
            :items="steps"
            :fields="stepfields"
          >
            <template #cell(step_number)="data">
              <span :class="data.item.step_number > parseInt(maxStepNumber) + 1 ? 'text-muted': ''">
                {{ data.item.step_number }}
              </span>
            </template>
            <template #cell(step_name)="data">
              <span :class="data.item.step_number > parseInt(maxStepNumber) + 1 ? 'text-muted': ''">
                {{ data.item.step_name }}
              </span>
            </template>
            <template #cell(status)="data">
              <span :class="data.item.step_number > parseInt(maxStepNumber) + 1 ? 'text-muted': ''">
                {{ data.item.status }}
              </span>
            </template>
            <template #cell(actions)="data">
              <BaseDropdown right class="w-100"
                v-if="data.item.step_number <= parseInt(maxStepNumber) + 1"
              >
                <template #button-content>
                  <i class="fa-solid fa-ellipsis"></i>
                </template>
                <li>
                  <router-link
                    class="dropdown-item"
                    :to="`/elearningstep/${data.item.id}`"
                  >
                    {{ data.item.actions }}
                  </router-link>
                </li>
              </BaseDropdown>
            </template>
          </BaseTable>
        </div>
      </div>

      <div v-if="(elearningmodule ? elearningmodule.module_learning_goals : '').trim() !== ''" class="accordion" role="tablist">
        <div class="card mb-1">
          <div class="card-header p-1" role="tab">
            <button class="btn btn-info w-100 text-left" @click="learningGoalsOpen = !learningGoalsOpen">Learning Goals</button>
          </div>
          <div v-show="learningGoalsOpen" class="card-body">
            <span v-html="elearningmodule ? elearningmodule.module_learning_goals : ''"></span>
          </div>
        </div>
      </div>

      <div class="accordion" role="tablist" v-if="elearningmaterials.length > 0">
        <div class="card mb-1">
          <div class="card-header p-1" role="tab">
            <button class="btn btn-info w-100 text-left" @click="requiredMaterialsOpen = !requiredMaterialsOpen">Required Materials</button>
          </div>
          <div v-show="requiredMaterialsOpen" class="card-body">
            <div v-for="material in elearningmaterials" :key="material.id">
              {{ material.material_heading }}
            </div>
          </div>
        </div>
      </div>

      <div v-if="(elearningmodule ? elearningmodule.module_references : '').trim() !== ''" class="accordion" role="tablist">
        <div class="card mb-1">
          <div class="card-header p-1" role="tab">
            <button class="btn btn-info w-100 text-left" @click="referencesOpen = !referencesOpen">References</button>
          </div>
          <div v-show="referencesOpen" class="card-body">
            <span v-html="elearningmodule ? elearningmodule.module_references : ''"></span>
          </div>
        </div>
      </div>
    </div>

    <div class="container-xl" v-if="elearningmodule && elearningmodule.exam_id !== '0'">
      <div class="border-0 text-container-wider">
        <div class="card-title">
          <h2 class="text-primary">
            {{ elearningmodule ? elearningmodule.module_name : '' }}
          </h2>
          <LearningExam :exam-id="elearningmodule.exam_id" :course-id="course_id" :module-id="module_id"/>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Navbar from './Navbar.vue'
import Breadcrumb from './Breadcrumb.vue'
import LearningExam from './LearningExam.vue'
import BaseDropdown from './base/BaseDropdown.vue'
import BaseTable from './base/BaseTable.vue'

const stepfields = [
  { key: 'step_number', label: '', thClass: 'col-1' },
  { key: 'step_name', label: '', thClass: 'col-8' },
  { key: 'progressText', label: 'Status', thClass: 'col-2' },
  { key: 'actions', label: 'Actions', class: 'ellipsis-button' }
]

export default {
  name: 'LearningModule',
  components: {
    Navbar,
    Breadcrumb,
    LearningExam,
    BaseDropdown,
    BaseTable
  },
  data () {
    return {
      routemeta: this.$route.meta,
      consultant_id: this.$store.state.user_id,
      course_id: null,
      module_id: this.$route.params.m ? this.$route.params.m : 0,
      elearningmodule: null,
      steps: [],
      stepfields,
      elearningmaterials: [],
      progress: 0,
      progressText: '',
      consultantstatus: [],
      stepsdone: [],
      breadcrumbOverride: [],
      maxStepNumber: 0,
      learningGoalsOpen: false,
      requiredMaterialsOpen: false,
      referencesOpen: false
    }
  },
  created () {
    this.module_get()
  },
  methods: {
    course_get () {
      this.$store.dispatch('record_read', { table_name: 'g_elearning_courses', id: this.course_id })
        .then((resp) => {
          this.elearningcourse = resp.data
          this.breadcrumbOverride = [
            { to: '/', text: 'My GDQ Management' },
            { to: '/learninghub', text: 'Learning Hub' },
            { to: `/elearningcourse/${this.elearningcourse.id}/0`, text: `${this.elearningcourse.course_name}` },
            { to: '/', text: `${this.elearningmodule.module_name}` }
          ]
        })
    },
    async materials_get () {
      const material_ids = await this.$store.dispatch('records_readall', { table_name: 'g_elearning_modules_materials', filter: { g_elearning_modules: { operator: '=', value: this.module_id } } })
        .then((resp) => {
          return resp.data.result.map(m => m.g_elearning_materials)
        })
      const elearningmaterials = await this.$store.dispatch('record_readlist', { table_name: 'g_elearning_materials', filter: { id: { operator: 'IN', value: material_ids.toString() } } })
        .then((resp) => {
          return resp.data.result
        })
      this.elearningmaterials = elearningmaterials
    },
    module_get () {
      this.$store.dispatch('record_read', { table_name: 'g_elearning_modules', id: this.module_id })
        .then((resp) => {
          this.elearningmodule = resp.data
          this.course_id = resp.data.course_id
          this.course_get()
          this.materials_get()
          this.steps_get()
        })
    },
    async steps_get () {
      await this.$store.dispatch('elearning_consultant_module_getsteps', { consultant_id: this.consultant_id, module_id: this.module_id })
        .then((resp) => {
          console.log(resp.data.result)
          const steps = resp.data.result.map((s) => {
            if (s.steps_done > this.maxStepNumber) {
              this.maxStepNumber = s.steps_done
            }
            return {
              ...s,
              progressText: s.steps_done >= s.step_number ? 'Completed' : 'Not started',
              actions: s.steps_done >= s.step_number ? 'View' : 'Start'
            }
          })
          this.steps = steps
        })
      // const steprows =
      //   await this.$store.dispatch(
      //     'record_readlist',
      //     {
      //       table_name: 'g_elearning_steps',
      //       filter: {
      //         module_id: {
      //           operator: '=',
      //           value: this.module_id
      //         }
      //       },
      //       orderby: 'step_number'
      //     }
      //   )
      // const steps = steprows.data.result;
      // this.steps = steps.map((s, i) => {
      //   return {
      //     ...s,
      //     progressText: 'Not started',
      //     actions: 'Start',
      //   }
      // });
      // const statusrows = await this.$store.dispatch('elearning_consultantstatus', { course_id: this.course_id })
      // this.consultantstatus = statusrows.data.result;
      // this.stepsdone = this.consultantstatus.filter(s => parseInt(s.module_id) == this.elearningmodule.id);
      // this.progress = this.stepsdone.length / this.steps.length;
      // this.progressText = this.progress == 0 ? 'Not started' : this.progress == 1 ? 'Completed' : 'In progress';
      // const statussteps = this.steps.map((s, i) => {
      //   const stepStatus = this.consultantstatus.find(cs => parseInt(cs.step_id) == parseInt(s.id));
      //   if (stepStatus && s.step_number > this.maxStepNumber) {
      //     this.maxStepNumber = s.step_number;
      //   }
      //   return {
      //     ...s,
      //     progressText: stepStatus ? 'Completed' : 'Not started',
      //     actions: stepStatus ? 'View' : 'Start',
      //   }
      // });
      // this.steps = statussteps;
    },
    step_set (item) {
      this.$router.push({ path: '/elearningstep/' + item.id })
    },
    goback () {
      this.$router.push({ path: '/elearningcourse/' + this.elearningmodule.course_id + '/1' })
    },
    gohome () {
      this.$router.push({ path: '/learninghub' })
    }
  }
}
</script>
